import { memo } from 'react';

/**
 * Component that renders a children component if 'value' is true.
 *
 * @param {object} props - The params of rendering.
 * @param {boolean} props.value - If 'true' return children else return 'null'.
 */
const If = ({ value, children }) => (value ? children : null);

export default memo(If);
